export enum AuthRestoreRBPasswordStep {
	Secret,
	Document,
	Birthday,
	ApproveOtp,
	SetNewPassword,
}
